import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/store.user.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { user },
});
